export const isTokenExpired = () => {
  const expiresAt = localStorage.getItem('expiresAt');
  if (!expiresAt) return true;
  const expiresAtNumber = parseInt(expiresAt, 10);  
  return Date.now() > expiresAtNumber;
};
  
  // utils/authUtils.js
  // utils/authUtils.js
export const handleLogin = async () => {
  try {

    const previous_user_id = localStorage.getItem('user_id');    
   
    const response = await fetch(`/api/init_app`, {    
      method: 'POST',      
      headers: {
        'Content-Type': 'application/json',
        // 'X-CSRFToken': csrfToken,
      },
      withCredentials: true,
      // credentials: 'include',
      body: JSON.stringify({
        'user_id': previous_user_id === null ? '' : previous_user_id 
      }) 
    });

    if (!response.ok) {
      const errorData = await response.json();
      console.error('Login error:', errorData.error);
      return;
    }

    // console.log('response ->', response);

    const result = await response.json();
    const { expires_in, user_id } = result;
   
    // console.log('expires_in ->', expires_in);    
    // console.log('result ->', result);
    // console.log('expires_in ->', expires_in);
    // console.log('user_id ->', user_id);
    if (user_id) {
      // localStorage.removeItem('token');
      localStorage.removeItem('expiresAt');
      localStorage.removeItem('user_id');

      // localStorage.setItem('token', result.access_token);
      const expireAt = (Date.now() + expires_in * 1000).toString();
      
      // console.log('expireAt -> ', expireAt);

      localStorage.setItem('expiresAt', expireAt);      
      localStorage.setItem('user_id', user_id);      
    }
  } catch (error) {
    console.error('An error occurred during login:', error);
  }
};